import SelectUserLanguages from "./select-user-languages";

export default SelectUserLanguages;